<template>
  <footer class="footer">
    <div class="footer__content">
      <div class="container">
        <div class="footer__text">
          <p>Срок акции с&nbsp;&laquo;01&raquo; декабря 2022&nbsp;г. &mdash;&nbsp;&laquo;31&raquo; марта 2023&nbsp;г.</p>
          <p>Информация об&nbsp;организаторе, о&nbsp;правилах, количестве призов, сроках, месте и&nbsp;порядке их&nbsp;получения на&nbsp;сайте <a href="https://www.poetti.ru/master" target="_blank">www.poetti.ru/master</a></p>
          <p>*В соответствии с пунктами 1.5.1. и 2.6. Правил использования баллов на <a href="https://www.ozon.ru/" target="_blank">ozon.ru</a> для получения Приза за репост Участнику <br>необходимо заплатить 1 рубль на сайте маркетплейса «Ozon» <a href="https://www.ozon.ru/" target="_blank">www.ozon.ru</a></p>
        </div>
        <!-- <div class="footer__copyright">
          © <span>{{ year }}</span> Все права защищены.
        </div> -->
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: ["partners"],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      docs: [
        {
          name: "Конфиденциальность",
          path: "terms-of-use.pdf",
        },
        {
          name: "Пользовательское соглашение",
          path: "terms-of-use.pdf",
        },
      ],
    };
  },
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  computed: {
    year() {
      let date = new Date();
      return date.getFullYear();
    },
  },
};
</script>
<style scoped lang="scss">
.footer {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 rem(7px);
  border-bottom: none;
  color: rgba(234, 231, 226, 0.51);
  text-align: center;
  z-index: 10;
  .container {
    padding-top: rem(30px);
    padding-bottom: rem(30px);
  }
  &__row,
  &__docs {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__text,
  &__copyright {
    font-size: rem(10px);
    line-height: 1.5;
    font-weight: 400;
    p {
      margin-bottom: rem(5px);
    }
    a {
      text-decoration: underline;
    }
  }
  &__col {
    width: 100%;
  }
  &__copyright {
    margin-top: rem(12px);
  }

  @media (min-width: $md) {
    padding: rem(100px) 0 rem(80px);
    font-size: rem(16px);
    .container {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    &__content {
      padding-top: 0;
      background: none;
    }
    &__row {
      flex-direction: row;
      justify-content: space-between;
    }
    &__copyright {
      margin-top: 0;
      text-align: left;
      font-size: rem(16px);
    }
    &__text {
      font-size: rem(16px);
      line-height: 1.5;
    }
    &__col {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      &:last-of-type {
        flex: 0 0 58%;
      }
    }
  }
}
</style>
